import React from 'react'
import PropTypes from 'prop-types'

import { Box, Typography, Button } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons'

import { PageTitle } from '@scoir/headers'

import StepHeader from './StepHeader'
import AvailabilityHeader from './AvailabilityHeader'
import AudienceInsights from './AudienceInsights'

const ActivateMessaging = ({ config }) => {
  const messagingActivated = config && config.messagingActivated
  const matchingActivated = config && config.matchingActivated

  return !messagingActivated ? (
    <>
      <AvailabilityHeader />
      <PageTitle 
      title="Link Slate to Scoir"
      subTitleProps={{py: 0}}
      subTitle={
        <Typography
          variant="h6"
          component="h3"
        >
          Put your followers at your fingertips and gain insights into first source and stealth.*
        </Typography>
      } />
      <AudienceInsights />
      <Box mt={3}>
        <Typography 
          variant='subtitle1'>
          When you connect Scoir and Slate, you can begin to track all of your Scoir followers right in your database, including those you're otherwise unaware of. No subscription required, and a great alternative to name buys.
          <br /><br />
          Plus, we'll share valuable insights on these stealth records and help you attribute first source data accurately. You can even message your followers on Scoir right from Slate if you'd like. Here's to reducing the stress on your comms team!
        </Typography>
      </Box>
      <StepHeader
        number={1}
        text="Activate your Scoir Account in Slate"
        isActive={true}
        isComplete={false}
      />
      <Typography
        variant="h6"
        component="h3"
      >
        Add Scoir as a new Device Type
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
      >
        This lets Slate know which Scoir Account to connect to. It also routes your Scoir messages to the right place if you decide to message your followers on Scoir from Slate.
      </Typography>
      <Box py={3}>
        <Button
          variant="contained"
          size="large"
          color="primary"
          component="a"
          href="https://scoir.helpdocs.io/article/hxl1tybntt-for-colleges-slate-integration-message-scoir-students-from-slate"
          rel="noopener noreferrer"
          target="_blank"
        >
          Read Help Article&nbsp;&nbsp;
          <FontAwesomeIcon icon={faExternalLink} />
        </Button>
      </Box>
      <Typography
        variant="caption"
        color="textSecondary"
      >
        *Stealth records are interested Scoir students, or inquiries, not yet recorded in your CRM. These students can only be reached and unlocked by selecting Scoir as your mailing channel in Slate, or directly from your Scoir account. Scoir does not share the personally identifiable information of stealth students.
      </Typography>
    </>
  ) : (
    <>
      <AvailabilityHeader />
      <PageTitle 
         title="Link Slate to Scoir"
         subTitleProps={{py: 0}}
         subTitle={
           <Typography
             variant="h6"
             component="h3"
           >
             Put your followers at your fingertips and gain insights into first source and stealth.*
           </Typography>
         } />
      <AudienceInsights />
      <StepHeader
        number={1}
        text="Activate your Scoir Account in Slate"
        isActive={true}
        isComplete={messagingActivated}
      />
      {!matchingActivated && (
        <Box pb={1}>
          <Typography
            variant="h6"
            component="span"
          >
            Scoir is now a mailing channel in Slate
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
          >
            You can now message Scoir students from Deliver in Slate.
          </Typography>
        </Box>
      )}
    </>
  )
}

ActivateMessaging.propTypes = {
  config: PropTypes.object,
}

export default ActivateMessaging
